import React from 'react';
import { useSelector } from 'react-redux';
import { PostSidebar } from 'mm-ui-components';
import { getSecondaryHeader } from '../../store/secondaryHeader/secondaryHeader.selectors';

interface PostSidebarProps {
    adId1: string | null
    adId2: string | null
}


export const PostSidebarConnected: React.FunctionComponent<PostSidebarProps> = props => {
    const isSecondaryHeaderEnabled = !!useSelector(getSecondaryHeader);
  return <PostSidebar {...{ ...props, isSecondaryHeaderEnabled }} />;
};
